import { File, FileArchive, FileImage, FileSpreadsheet, FileText, Link2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export type FileKind = "pdf" | "image" | "doc" | "sheet" | "zip" | "link" | "other";

export function fileKind(kind: "upload" | "link", filename: string | null, contentType: string | null): FileKind {
  if (kind === "link") return "link";
  const ext = (filename ?? "").split(".").pop()?.toLowerCase() ?? "";
  if (ext === "pdf" || contentType === "application/pdf") return "pdf";
  if (["png", "jpg", "jpeg"].includes(ext) || contentType?.startsWith("image/")) return "image";
  if (ext === "docx") return "doc";
  if (ext === "xlsx") return "sheet";
  if (ext === "zip") return "zip";
  return "other";
}

const ICONS = { pdf: FileText, image: FileImage, doc: FileText, sheet: FileSpreadsheet, zip: FileArchive, link: Link2, other: File };

export function FileTypeIcon({ kind }: { kind: FileKind }) {
  const { t } = useTranslation();
  const Icon = ICONS[kind];
  return (
    <span className="inline-flex items-center gap-2">
      <Icon aria-hidden="true" className="h-5 w-5 shrink-0 text-accent" />
      <span>{t(`files.kind.${kind}`)}</span>
    </span>
  );
}
